module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_02-9cc7823b5f19313f27538b3fb44bba6c.png";